import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Portal from './components/Portal';
import Admin from './components/Admin';
import Loading from './components/Loading';
import Error from './components/Error';
import './styles/index.css';

function ProtectedRoute({ children }) {
  const { user, access, loading, isAuthenticated } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has any allowed sections
  if (!isAuthenticated || !access || access.sections?.length === 0) {
    return (
      <Error 
        title="Access Denied"
        message="You don't have access to any portal sections. Contact your administrator."
      />
    );
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/*" 
        element={
          <ProtectedRoute>
            <Portal />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
